<template>
    <div class="md user-set" :class="[show? 'is-active': '', islogin? 'is-login': '']">
        <template v-if="islogin">
            <a @click.prevent.stop="toggle()">
                <span class="name">
                    <span class="text">{{ user.cuabr || user.cufn || user.cuno }}</span>
                    <cpLabel
                        themes="info"
                        :text="$t('codiv.' + user.co + user.div)"
                    ></cpLabel>
                </span>
                <label
                    class="image"
                    :style="{
                        backgroundImage: 'url('+ userPhoto +')'
                    }"
                >
                    <img :src="userPhoto" :alt="user.cuno">
                </label>
            </a>
            <transition name="animate">
                <ul v-if="show" class="func data-panel" @click.stop>
                    <li class="data-header">
                        <div class="user-data">
                            <div
                                class="image"
                                :style="'background-image: url('+ userPhoto +')'"
                            ></div>
                            <div class="name">
                                <span class="text">{{ user.cuabr || user.cufn || user.cuno }}</span>
                                <cpLabel
                                    themes="info"
                                    :text="$t('codiv.' + user.co + user.div)"
                                ></cpLabel>
                            </div>
                            <div class="link">
                                <a class="icon-font person" @click.prevent="showAccount">{{ $t('site.func.profile') }}</a>
                                <a class="icon-font exit_to_app" @click.prevent="logoutFunc">{{ $t('site.func.logout') }}</a>
                            </div>
                        </div>
                    </li>
                    <li class="data-content">
                        <div class="accounts">
                            <a
                                v-for="item in useAccounts"
                                class="div"
                                :key="item.accountid"
                                @click="changeAccount(item)"
                            >
                                <div
                                    class="image"
                                    :style="'background-image: url('+ item.photo +'?timestamp='+ timestamp +')'"
                                ></div>
                                <div class="name">
                                    <span class="text">{{ item.name }}</span>
                                    <cpLabel
                                        themes="info"
                                        :text="$t('codiv.' + item.co + item.div)"
                                    ></cpLabel>
                                </div>
                                <div class="remove" @click.stop="remove(item)"></div>
                            </a>
                            <a
                                class="div"
                                @click="login"
                            >
                                <div class="icon">+</div>
                                <div class="name">
                                    <span class="text">{{ $t('add.account') }}</span>
                                </div>
                            </a>
                        </div>
                    </li>
                    <li><a class="icon-font error_outline" @click.prevent="showVersion" :title="$t('site.func.aboutUs')">{{ $t('site.func.aboutUs') }}</a></li>
                </ul>
            </transition>
        </template>
        <a v-else @click.prevent.stop="login">
            <span class="name">{{ $t('site.func.login') }}</span>
        </a>
    </div>
</template>

<script>
    import VueCookie from 'vue-cookie'
    import cpLabel from '@/components/cpLabel'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    export default {
        data: function(){

            return {
                id: 'user-set',
                show: false
            }
        },
        components: {
            cpLabel,
        },
        computed: {
            ...mapState([
                'user',
                'accounts',
                'timestamp',
                'token',
            ]),
            ...mapGetters([
                'userPhoto',
            ]),
            islogin: function(){
                return this.user.sn;
            },
            useAccounts: function(){
                let _id = this.user.accountid;

                return this.accounts.filter(account => account.id !== _id);
            }
        },
        methods: {
            ...mapActions([
                'getUser',
            ]),
            ...mapMutations([
                'changeState',
                'pushPopUp',
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
                'logout',
            ]),
            changeAccount: function(item){
                let _originalToken = this.token;

                this.changeState({
                    token: item.token,
                });

                this.hide();

                let _url = this.$siteTool.apiUrl({
                        class: 'users',
                        func: 'refresh',
                    });

                this.$http.post(_url, {}).then(res => { //弄完所有設定後開始取資料
                
                    this.getUser(res.token);

                    let $route = this.$route,
                        _path = $route.fullPath || '';

                    if( _path.includes('/system/orderInfo?inqtno=') ) {
                        this.$router.push('/system/account?page=purchase');
                    }
                }).catch(error => {

                    this.changeState({
                        token: _originalToken,
                    });

                    this.pushPopUp({
                        type: 'login',
                        content: {
                            id: item.id,
                        }
                    });
                });
            },
            remove: function(item){
                let $accounts = this.accounts,
                    $clone = this.$okaTool.copy($accounts);

                let $target = $clone.find(account => account.id === item.id);

                if( $target ) {
                    let _index = $clone.indexOf($target);

                    $clone.splice(_index, 1);
                        
                    this.changeState({
                        accounts: $clone,
                    });

                    VueCookie.set('accounts', JSON.stringify($clone), 3);
                }
            },
            showVersion: function(){
                this.pushPopUp({
                    type: 'aboutUs',
                });

                this.hide();
            },
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
            },
            hide: function(){
                this.show = false;
            },
            showAccount: function(){
                this.$router.push('/system/account');
                
                this.hide();
            },
            // showUserData: function(){
            //     this.pushPopUp({
            //        type: 'alert',
            //        content: {
            //            html: this.user.username
            //        }
            //     });

            //     this.hide();
            // },
            login: function(){

                this.pushPopUp({
                    type: 'login',
                });

                this.hide();
            },
            logoutFunc: function(){

                this.pushPopUp({
                    type: 'confirm',
                    content: {
                        html: this.$t('popup.logout.func.alert'),
                        actionName: this.$t('site.func.logout'),
                        action: () => {
                            this.logout(() => {
                                let _path = this.$route.path,
                                    $pathList = [ //在這些路由中不要導出
                                        '/system/productList',
                                        '/index',
                                        '/system/search',
                                    ]

                                if( !$pathList.includes(_path) ) {
                                    this.$router.push('/index');
                                }
                            });

                            this.hide();
                        }
                    }
                })
            },
        },
        created: function(){
            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">

    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .md.user-set {
        @extend %header-btn;

        .func {

            > li {

                > a {
                    max-width: none;
                }
            }
        }

        &.is-login {

            > a {
                padding-right: $interval-l;

                @include media('phone') {
                    padding-right: 0;

                    &::after {
                        display: none;
                    }
                }

                &::before {
                    content: '\e7fd';
                    margin-right: $interval-s;
                }

                &::after {
                    content: '\e5c5';
                }
            }
        }

        &.is-active {

            > a {
                background-color: $major-color;
                color: $white;

                &::before, &::after {
                    color: $white;
                }

                &::after {
                    content: '\e5c7';
                }
            }
        }

        > a {
            position: relative;

            .name {

                .text {
                    margin-right: $interval-xs;
                }

                @include media('phone') {
                    display: none;
                }
            }

            &:hover {
                background-color: $major-color;
                color: $white;

                &::before, &::after {
                    color: $white;
                }
            }

            &::before {
                content: '\e7ff';
                margin-right: $interval-s;

                @include media('phone') {
                    margin-right: 0;
                }
            }

            .image {
                $size: 24px;

                position: absolute;
                border-radius: 100%;
                overflow: hidden;
                left: 5px;
                top: 5px;
                width: $size;
                height: $size;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;

                img {
                    display: none;
                }
            }
        }
    }

    .is-mobile {
        display: none;

        @include media('mobile') {
            display: block;
        }
    }

    .data-panel {
        width: 230px;

        > li {

            + li {
                border-top: $border;
            }
        }
    }

    .data-header {
        
        .user-data {
            padding: $interval-m $interval-l;

            .image {
                width: 120px;
                height: 120px;
                margin: 0 auto;
                border-radius: 50%;
                background-repeat: no-repeat;
                background-position: center;
                background-size: cover;
                background-color: $minor-color;
            }

            .name {
                @extend %ellipsis;
                padding: $interval-s;
                text-align: center;

                .text {
                    font-size: $font-size-xl;
                    margin-right: $interval-xs;
                }
            }

            .link {
                text-align: center;

                a {
                    display: block;
                    padding: $interval-xs $interval-m;
                    border-radius: $border-radius;
                    border: $border;
                    transition: $transition;
                    cursor: pointer;

                    &:hover {
                        background: $light;
                    }

                    + a {
                        margin-top: $interval-s;
                    }
                }
            }
        }
    }

    .data-content {
        
        .accounts {
            $account_h: 32px;

            padding: $interval-s 0;

            a.div {
                display: flow-root;
                position: relative;
                padding: $interval-s $interval-m;
                transition: $transition;
                cursor: pointer;

                &:hover {
                    background: $light;
                }

                %circle {
                    float: left;
                    width: $account_h;
                    height: $account_h;
                    line-height: $account_h;
                    border-radius: 50%;
                }

                .icon {
                    @extend %circle;
                    text-align: center;
                    color: $white;
                    background-color: $major-color;
                }

                .image {
                    @extend %circle;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    background-color: $minor-color;
                }

                .name {
                    @extend %ellipsis;
                    line-height: $account_h;
                    padding-left: $interval-s;

                    .text {
                        margin-right: $interval-xs;
                    }
                }

                .remove {
                    $d: 16px;

                    transition: $transition;
                    position: absolute;
                    top: 0;
                    right: $interval-xs;
                    cursor: pointer;

                    &::before {
                        @extend %font-pseudo;
                        display: block;
                        content: '\e5cd';
                    }

                    &:hover {
                        color: $gray;
                    }
                }
            }
        }
    }
</style>
